"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _array = require("lodash/array");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function throwError(msg) {
  throw new Error(msg);
}

var LottieAnimationAPI = /*#__PURE__*/function () {
  function LottieAnimationAPI() {
    _classCallCheck(this, LottieAnimationAPI);
  }

  _createClass(LottieAnimationAPI, [{
    key: "_validate",
    value: function _validate() {
      if (this.animation === undefined) {
        throwError('Animation is not render - need to render');
      }
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {}
  }, {
    key: "render",
    value: function render(container) {
      this._loadAnimation(this.json, container);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventName, callback) {
      this._validate();

      this.animation.addEventListener(eventName, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventName, callback) {
      this._validate();

      this.animation.removeEventListener(eventName, callback);
    }
  }, {
    key: "goToAndStop",
    value: function goToAndStop(time) {
      this._validate();

      this.animation.goToAndStop(time);
    }
  }, {
    key: "goToAndPlay",
    value: function goToAndPlay(time) {
      this._validate();

      this.animation.goToAndPlay(time);
    }
  }, {
    key: "playSegments",
    value: function playSegments(segments) {
      this._validate(); // flatt array


      var flatt = (0, _array.flattenDeep)(segments); // chamge value from millisecond to frames

      var segmentsFrames = flatt.map(function (x) {
        return x / 40;
      }); // applay function

      this.animation.playSegments((0, _array.chunk)(segmentsFrames, 2), true);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._validate();

      if (this.ready) {
        this.animation.destroy();
        delete this.ready;
        delete this.imagesLoaded;
        delete this.DOMLoaded;
        delete this.animation;
        this.innerContainer.remove();
      } else {
        this.afterReady = this.destroy;
      }
    }
  }, {
    key: "getScaledTime",
    value: function getScaledTime(time) {
      var inDuration = this.inDuration,
          originInDuration = this.originInDuration,
          intermissionDuration = this.intermissionDuration,
          outDuration = this.outDuration,
          originOutDuration = this.originOutDuration;
      var inD = Math.min(time, inDuration) * originInDuration / inDuration;
      var intermissionD = Math.min(Math.max(time - inDuration, 0), intermissionDuration);
      var ot = time - inDuration - intermissionDuration;
      var outD = Math.min(Math.max(ot, 0), outDuration) * originOutDuration / outDuration;
      return inD + intermissionD + outD;
    }
  }]);

  return LottieAnimationAPI;
}();

exports.default = LottieAnimationAPI;